var map = {
	"./WhatsApp Image 2025-01-30 at 2.42.12 PM.jpeg": 58598,
	"./WhatsApp Image 2025-01-30 at 2.42.13 PM (1).jpeg": 72753,
	"./WhatsApp Image 2025-01-30 at 2.42.13 PM.jpeg": 46603,
	"./WhatsApp Image 2025-01-30 at 2.42.14 PM.jpeg": 70712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30468;